import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowleftFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "6",
    height: "12",
    fill: "none",
    viewBox: "0 0 6 12",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.878 11.777.303 6.763a1.2 1.2 0 0 1-.23-.357A1.1 1.1 0 0 1 0 6a1.1 1.1 0 0 1 .073-.406q.072-.185.23-.357L4.878.223A.7.7 0 0 1 5.089.06.54.54 0 0 1 5.34 0q.267 0 .464.198A.7.7 0 0 1 6 .719v10.562q0 .324-.199.521a.64.64 0 0 1-.463.198q-.067 0-.46-.223"
  }));
}
var IcArrowleftFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowleftFillNomargin));

export { IcArrowleftFillNomargin as I };
